import React, { Component } from 'react';
import { Link } from "react-router-dom"
import favouritedPacksStore from '../../stores/favouritedPacksStore';
import packStore from '../../stores/packStore';
import RemoveCollection from '#images/remove-collection.png'

class FavouritedPack extends Component {
  unfavourite = (e) => {
    const { id } = this.props.pack
    e.preventDefault();
    e.stopPropagation();
    // updates pack page if current pack being unfavourited
    if (packStore.id === id) {
      packStore.unfavourite()
    } else {
      favouritedPacksStore.unfavourite(id);
    }
  }

  render() {
    const { id, title, label_name, cover_google_merchant, seo_label_id, label_id } = this.props.pack
    return (
      <Link
        to={"/product/" + id}
        className='border-b border-gray-11 first-of-type:border-t hover:bg-gray-15 group'
      >
        <div className='flex'>
          <div className='flex'>
            <img
              src={cover_google_merchant}
              className='min-h-[80px] max-h-[80px] min-w-[80px] max-w-[80px] object-fill'
            />
          </div>

          <div className='flex flex-col pl-2.5 pr-4 py-2 min-w-0 max-w-full'>
            <p className='text-[15px] leading-none h-1/2 pt-1 font-bold line-clamp-2 break-words [word-break:break-word]'>{title}</p>
            <Link to={"/label/" + (seo_label_id || label_id)} className='mt-auto'>
              <p className='mt-2 text-xs text-gray-3 line-clamp-1 leading-none pt-1'>{label_name}</p>
            </Link>
          </div>

          <div className='invisible group-hover:visible py-2.5 ml-auto min-w-fit pr-1'>
            <img
              onClick={this.unfavourite}
              src={RemoveCollection}
              className='hover:brightness-200 w-[20px] h-[20px]'
            />
          </div>
        </div>
      </Link>
    )
  }
}

export default FavouritedPack;
